/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/tableAcrylic.glb 
*/

import React, { useEffect, useRef } from "react";
import { shaderMaterial, useGLTF, useTexture } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const FrameMaterial = shaderMaterial(
  {
    uTexture: new THREE.Texture(),
    utextureSize: new THREE.Vector2(),
  },
  `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  `
uniform sampler2D uTexture;
uniform vec2 utextureSize;

varying vec2 vUv;

void main() {
    gl_FragColor = texture2D(uTexture, vUv);
}

  `
);
extend({ FrameMaterial });

export function TableAcrylic({
  image = "/br.jpg",
  frameSize = { width: 12, height: 12 },
  Tablecolor = "#CBA35C",
  PotColor = "#B6CBBD",
  PlantBcolor = "#F8E1B7",
  color = "white",
  ...props
}) {
  const { nodes, materials } = useGLTF("/3d/tableAcrylic.glb");
  const texture = useTexture(image);
  texture.flipY = false;
  const envMap = useTexture("/3d/gainmap.jpg");
  envMap.mapping = THREE.EquirectangularReflectionMapping;
  const materialRef = useRef();
  const container = useRef(null);

  const [aspectX, aspectY] = [frameSize.width, frameSize.height];
  const baseSize = 2;
  const scaleX = (aspectX / Math.max(aspectX, aspectY)) * baseSize;
  const scaleY = (aspectY / Math.max(aspectX, aspectY)) * baseSize;
  const yPosition = -scaleY + 0.99;

  useEffect(() => {
    if (materialRef.current) {
      materialRef.current.uniforms.uTexture.value = texture;
      materialRef.current.uniforms.utextureSize.value.set(1,1);
    }
  }, [texture]);

  useFrame(() => {
    if (container.current) {
      container.current.rotation.y += 0.0015;
    }
  });
  return (
    <>
      <group
        ref={container}
        receiveShadow
        castShadow
        {...props}
        dispose={null}
        position={[0, -1.6, 0]}
        rotation={[0, -Math.PI / 2, 0]}
      >
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.Table003.geometry}
          material={nodes.Table003.material}
          position={[-0.003, 0.06, 0.002]}
          rotation={[-Math.PI / 2, 0, 0]}
          scale={[0.9, 0.9, 0.9]}
        >
          <meshStandardMaterial color={Tablecolor} side={THREE.DoubleSide} />
        </mesh>
        <group receiveShadow castShadow position={[0.07, -0.03, 0.1]}>
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder006_Flowerpot5_0003.geometry}
            material={nodes.Cylinder006_Flowerpot5_0003.material}
            position={[0.078, 1.077, 0.453]}
            rotation={[-Math.PI / 2, 0, 0]}
          >
            <meshBasicMaterial color={PlantBcolor} />
          </mesh>
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Plane081_Haworthia_leaf_0003.geometry}
            material={materials["Haworthia_leaf.003"]}
            position={[0.113, 1.162, 0.458]}
          />
        </group>
        <group position={[0.125, -0.03, -0.15]}>
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Object_4003.geometry}
            material={materials["Material.027"]}
            position={[0, 1.008, -0.386]}
            scale={0.168}
          >
            <meshBasicMaterial color={PotColor} />
          </mesh>
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Object_5002.geometry}
            material={materials["Material.028"]}
            position={[0, 1.008, -0.386]}
            scale={0.168}
          >
            <meshBasicMaterial color={PotColor} />
          </mesh>
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cube_Metal_0002.geometry}
            material={materials["Metal.003"]}
            position={[-0.044, 1.287, -0.403]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={[0.009, 0.013, 0.002]}
          />
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder_BlackMetal_0002.geometry}
            material={materials["BlackMetal.003"]}
            position={[-0.055, 1.163, -0.395]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={0.172}
          />
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder_Metal_0002.geometry}
            material={materials["Metal.003"]}
            position={[-0.055, 1.163, -0.395]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={0.172}
          />
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder001_Material_0002.geometry}
            material={materials["Material.029"]}
            position={[-0.008, 1.144, -0.35]}
            rotation={[0.279, -0.05, -0.025]}
            scale={0.001}
          />
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder002_Material002_0002.geometry}
            material={materials["Material.030"]}
            position={[-0.008, 1.148, -0.349]}
            rotation={[0.279, -0.05, -0.025]}
            scale={0.001}
          />
          <mesh
            receiveShadow
            castShadow
            geometry={nodes.Cylinder_Material001_0005.geometry}
            material={materials["Material.031"]}
            position={[-0.008, 1.144, -0.35]}
            rotation={[0.279, -0.05, -0.025]}
            scale={0.001}
          />
          <group position={[-0.03, -0.02, 0]}>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.Cylinder001_Material004_0002.geometry}
              material={materials["Material.032"]}
              position={[0.046, 1.283, -0.469]}
              rotation={[2.77, -0.212, 0.062]}
              scale={0.0005}
            />
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.Cylinder002_Material005_0002.geometry}
              material={materials["Material.033"]}
              position={[0.047, 1.295, -0.474]}
              rotation={[2.77, -0.212, 0.062]}
              scale={0.00015}
            />
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.Cylinder003_Material002_0002.geometry}
              material={materials["Material.034"]}
              position={[0.04, 1.185, -0.43]}
              rotation={[2.77, -0.212, 0.062]}
              scale={0.0005}
            />
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.Cylinder_Material001_0006.geometry}
              material={materials["Material.035"]}
              position={[0.04, 1.185, -0.43]}
              rotation={[2.77, -0.212, 0.062]}
              scale={0.0005}
            />
          </group>
        </group>
        <group position={[0, -0.037, -0.075]}>
          <group
            receiveShadow
            castShadow
            scale={[1.0, scaleY, scaleX]}
            position={[0, yPosition, 0]}
          >
            <group scale={[1.0, 0.8, 0.8]} position={[0, 0.2, 0]}>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.Plane.geometry}
                material={nodes.Plane.material}
                position={[-0.057, 1.228, 0.041]}
                rotation={[Math.PI / 2, 0.062, -Math.PI / 2]}
                scale={[0.216, 0.064, 0.216]}
              >
                <meshPhysicalMaterial
                  color="white"
                  roughness={0.1}
                  metalness={0.1}
                  thickness={0.5}
                  ior={1.5}
                  envMap={envMap}
                  envMapIntensity={1}
                  side={THREE.DoubleSide}
                />
              </mesh>
              <mesh
                receiveShadow
                castShadow
                geometry={nodes.Plane001.geometry}
                material={nodes.Plane001.material}
                position={[-0.057, 1.229, 0.041]}
                rotation={[-Math.PI / 2, -0.062, -Math.PI / 2]}
                scale={[0.216, 0.064, 0.216]}
              >
                <meshPhysicalMaterial
                  color="white"
                  transparent={true}
                  opacity={0.3}
                  roughness={0.1}
                  reflectivity={0.1}
                  metalness={0.9}
                  transmission={1.0}
                  thickness={0.5}
                  ior={1.5}
                  envMap={envMap}
                  envMapIntensity={1}
                  side={THREE.DoubleSide}
                />
              </mesh>
              <group receiveShadow castShadow>
                <mesh
                  receiveShadow
                  castShadow
                  geometry={nodes.Plane001.geometry}
                  material={nodes.Plane001.material}
                  position={[-0.057, 1.228, 0.041]}
                  rotation={[Math.PI / 2, 0.062, -Math.PI / 2]}
                  scale={[0.216, 0.064, 0.216]}
                >
                  <frameMaterial
                    ref={materialRef}
                    key={FrameMaterial.key}
                    side={THREE.DoubleSide}
                  />
                </mesh>
              </group>
              <group position={[0, 0, 0]}>
                <mesh
                  receiveShadow
                  castShadow
                  geometry={nodes.Cube.geometry}
                  material={nodes.Cube.material}
                  position={[-0.072, 1.345, 0.041]}
                  rotation={[Math.PI / 2, 0.062, Math.PI / 2]}
                  scale={[-0.038, -0.001, -0.032]}
                >
                  <meshStandardMaterial
                    color="white"
                    envMap={envMap}
                    envMapIntensity={1}
                  />
                </mesh>
                <mesh
                  receiveShadow
                  castShadow
                  geometry={nodes.Cube001.geometry}
                  material={nodes.Cube001.material}
                  position={[-0.061, 1.173, 0.041]}
                  rotation={[Math.PI / 2, 0.062, Math.PI / 2]}
                  scale={[-0.038, -0.001, -0.023]}
                >
                  <meshStandardMaterial
                    color="white"
                    envMap={envMap}
                    envMapIntensity={1}
                  />
                </mesh>
                <mesh
                  receiveShadow
                  castShadow
                  geometry={nodes.Plane002.geometry}
                  material={nodes.Plane002.material}
                  position={[-0.119, 1.085, 0.041]}
                  rotation={[-Math.PI / 2, 0.575, Math.PI / 2]}
                  scale={[0.037, 0.161, 0.087]}
                >
                  <meshStandardMaterial
                    color="white"
                    envMap={envMap}
                    envMapIntensity={1}
                  />
                </mesh>
              </group>
            </group>
          </group>
        </group>
      </group>
    </>
  );
}

useGLTF.preload("/3d/tableAcrylic.glb");
